import React, { Fragment } from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import styled from "styled-components";

class TextExceed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      overflows: false,
    };
    this.updateWidth = this.updateWidth.bind(this);
  }
  static propTypes = {
    tooltipClassName: PropTypes.string,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };
  static defaultProps = {
    tooltipClassName: "",
    tooltipPosition: "right"
  };

  updateWidth() {
    if (!this.el) {
      return;
    }
    // const width = this.el.clientWidth;
    // const scrollWidth = this.el.scrollWidth;
    // if (this.state.width !== width) {
    //   this.setState({ width });
    // }
    // this.setState({ overflows: width < scrollWidth });

    const height = this.el.clientHeight;
    const scrollHeight = this.el.scrollHeight;
    if (this.state.height !== height) {
      this.setState({ height });
    }
    this.setState({ overflows: height < scrollHeight });
  }
  UNSAFE_componentWillMount() {
    window.addEventListener("resize", this.updateWidth);
  }
  componentDidMount() {
    this.updateWidth();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }
  render() {
    return (
      <TextExceedContainer>

        {
          this.state.overflows ?
          <>
            <div
              ref={(el) => {
                if (el) this.el = el;
              }}
              className="custom-text-exceed-content"
              data-tip
              data-for={"tooltip-".concat(this.props.name)}
            >
              {this.props.children}
            </div>

            <ReactTooltip
              id={"tooltip-".concat(this.props.name)}
              place="top"
              className='eta-tooltip-content'
              event="mouseover"
              eventOff="mouseleave"
            > 
              {this.props.children}
            </ReactTooltip>
          </> : 
          <div
            ref={(el) => {
              if (el) this.el = el;
            }}
            className="custom-text-exceed-content"
          >
            {this.props.children}
          </div>
        }

      </TextExceedContainer>
    );
  }
}

export default TextExceed;

const TextExceedContainer = styled.div`
  position: relative;

  & .custom-text-exceed-content {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 16px;
  }
`;